import { useTheme } from '@mui/material'
import ListItemButton from '@mui/material/ListItemButton'
import { Link } from 'react-router-dom'

import { useRoutes } from 'app/use_routes'
import { isEmpty } from 'components-ui/src/shared'
import { Types } from 'service-api'
import { getRouteForConf } from './helper'

interface TListLinkProps {
  conf: Types.LocationPreRegistrationConfValidationClientDto
  petProfileId?: string
}

export const ListLink = ({ conf, petProfileId }: TListLinkProps) => {
  const { buildPath } = useRoutes()
  const theme = useTheme()
  const routeConf = getRouteForConf(conf)

  let routePath = buildPath(getRouteForConf(conf).route, { lppId: petProfileId })
  if (!isEmpty(routeConf.anchor)) {
    routePath += `#${routeConf.anchor}`
  }

  return (
    <ListItemButton disableGutters sx={{ flexGrow: 0, p: 0, ml: 0.5, '& > div': { m: 0 } }}>
      <Link to={routePath} style={{ color: theme.palette.primary.main }}>
        {conf.bookingDisplayName || ''}
      </Link>
    </ListItemButton>
  )
}
